import { FC, useState, ChangeEvent, useEffect, useMemo } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import { Divider, FormControlLabel, ListItemIcon, Switch } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getMessages } from 'redux/reducers/user/selectors';
import { TMessagesRow } from 'redux/reducers/user/types';
import useInterval from 'use-interval';
import { getMessagesRequest } from 'redux/reducers/user/reducer';
import { nanoid } from '@reduxjs/toolkit';
import { TUserMenuProps } from './types';
import { MessagesMenuItem, MessagesMenuItemMemo } from './MessagesMenuItem';

export const MessagesMenu: FC<TUserMenuProps> = ({ anchorEl, handleCloseMenu }) => {
	const dispatch = useDispatch();
	const messagesData = useSelector(getMessages);

	const [selectMessage, setSelectMessage] = useState<number | null>(null);

	const messages = useMemo(() => messagesData?.data, [messagesData]);

	const [showUnread, setShowUnread] = useState(false);
	const handleChangeShowUnread = (event: ChangeEvent<HTMLInputElement>) => {
		setShowUnread(event.target.checked);
	};
	useEffect(() => {
		if (!anchorEl) return;
		dispatch(getMessagesRequest());
	}, [dispatch, anchorEl]);

	useInterval(
		() => {
			if (!anchorEl) return;
			dispatch(getMessagesRequest());
		},
		// 5 * 60_000
		20_000,
	);

	return (
		<Menu
			sx={{ mt: '45px', overflowY: 'auto' }}
			id="menu-appbar"
			anchorEl={anchorEl}
			anchorOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}
			keepMounted
			transformOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}
			open={Boolean(anchorEl)}
			onClose={handleCloseMenu}
		>
			<Box
				sx={{
					maxWidth: '600px',
				}}
			>
				<Box
					sx={{
						p: '6px 16px 6px 16px',
						maxWidth: '600px',
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'space-between',
						position: 'sticky',
						top: 0,
						backgroundColor: '#fff',
						zIndex: 1000,
					}}
				>
					<Typography
						textAlign="left"
						variant="h5"
						component="h5"
						color="primary"
						sx={{ fontWeight: 900, marginLeft: '0px' }}
					>
						Messages
					</Typography>
					<FormControlLabel
						control={<Switch value={showUnread} onChange={handleChangeShowUnread} />}
						label="show unread messages only"
						labelPlacement="start"
					/>
				</Box>
				{messages
					// ?.filter((item) => {
					// 	if (showUnread) {
					// 		return item.is_read === false;
					// 	}
					// 	return true;
					// })
					?.map((message: TMessagesRow, index) => {
						if (showUnread && message.isRead === true && index !== selectMessage) {
							return null;
						}

						return (
							<Box key={nanoid()}>
								<MessagesMenuItemMemo
									message={message}
									selectedMessage={selectMessage === index}
									onSelectMessage={(selected: boolean) => setSelectMessage(selected ? index : null)}
								/>
								{index === messages.length - 1 ||
								index === selectMessage ||
								(selectMessage ?? 0) - 1 === index ? null : (
									<Divider variant="middle" sx={{ marginTop: '10px' }} />
								)}
							</Box>
						);
					}) ?? <Typography>No messages</Typography>}
			</Box>
		</Menu>
	);
};
